import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import DatePicker from "react-datepicker";
import "./TaskDetails.css";
import Navbar from "../../Navbar/Navbar";
import { format, formatDate, isValid, parse } from "date-fns";
import Select from 'react-select';
import { MentionsInput, Mention } from "react-mentions";

import {
  getProjectMasterByLoginId,
  getcreateTask,
  taskMasterList,
  getTaskDetails,
  getTaskTransactionDetails,
  gettaskpriority,
  gettaskstatus,
  gettasktype,
  addTaskComment,
  addTaskWorklog,
  getWorklogData,
  getCommentData,
  fetchTodyasWorkLogDataByLogind,
} from "../../../Redux/Task/Action";
import { getEmpListByProjectId } from "../../../Redux/DailyUpdateApproval/Action";
import Swal from "sweetalert2";
import { FaEdit } from "react-icons/fa";
import { BiSolidMessageRoundedDetail } from "react-icons/bi";
import { IoTimeOutline } from "react-icons/io5";
import NewGlobalDataTable from "../../DataTable/NewGlobalDataTable";
import Icon from "../../utility/Icon";
import { isEditable } from "@testing-library/user-event/dist/utils";
import { Alignment } from "react-data-table-component";

const TaskDetails = () => {
  const token = localStorage.getItem("token");
  const loginId = localStorage.getItem("loginId");
  const roleName = localStorage.getItem("role");
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const [showCommentModal, setshowCommentModal] = useState(false);
  const [showWorklogModal, setshowWorklogModal] = useState(false);
  const [pageSize, setPageSize] = useState(10);
  const [pageNumber, setPageNumber] = useState(1);
  const [showTable, setShowTable] = useState(false);
  const [searchText, setSearchText] = useState("");

  const [value, setValue] = useState("");
  const [mentionedUsers, setMentionedUsers] = useState([]);

  const {
    getProjectAsLoginId,
    tasklist,
    taskEdit,
    taskType,
    taskPriority,
    taskStatus,
    taskWorklogdata,
    taskCommentData,
    todaysWorklogDataByid,
    taskTransactionList,
  } = useSelector((store) => store.task);
  const { empListByProjectId } = useSelector((store) => store.dailyUpdateApprover);
  const [onEditing, setonEditing] = useState(false);
  const [taskId, setTaskId] = useState("");
  const [taskNumber, setTaskNumber] = useState("");
  const [taskTitle, setTaskTitle] = useState("");
  const [task, setTask] = useState({
    projectCode: "",
    module: "",
    title: "",
    type: "",
    startDate: "",
    endDate: "",
    effortReq: 0,
    effortActual: 0,
    priorityCode: "",
    assignId: "",
    ownerShipId: "",
    status: "",
    taskDesc: "",
    remark: "",
    actionType: "INSERT",
    initiatorId: loginId,
    hrmsTaskMasterId: "",
  });

  const [comment, setComment] = useState({
    comments: "",
  });
  const [workLog, setworkLog] = useState({
    date: new Date(),
    totalHour: "",
    remarks: "",
  });
  const handleShow = () => {
    setTask({
      projectCode: "",
      module: "",
      title: "",
      type: "",
      startDate: "",
      endDate: "",
      effortReq: "",
      effortActual: "",
      priorityCode: "",
      assignId: "",
      ownerShipId: "",
      status: "",
      taskDesc: "",
      remark: "",
      actionType: "INSERT",
      initiatorId: loginId,
      hrmsTaskMasterId: "",
    });
    setonEditing(false);
    setShow(true);
  };

  useEffect(() => {
    dispatch(getProjectMasterByLoginId(roleName, loginId, token));
    dispatch(gettaskpriority(token));
    dispatch(gettaskstatus(token));
    dispatch(gettasktype(token));
  }, [dispatch, token]);

  useEffect(() => {
    dispatch(taskMasterList(token, pageNumber - 1, pageSize, loginId, roleName, searchText));
  }, [dispatch, token, pageNumber, pageSize, searchText]);


  useEffect(() => {
    if (taskEdit) {
      setTask((prevData) => ({
        ...prevData,
        projectCode: taskEdit.projectCode,
        module: taskEdit.module,
        title: taskEdit.title,
        type: taskEdit.type,
        startDate: taskEdit.startDate,
        endDate: taskEdit.endDate,
        effortReq: taskEdit.effortReq,
        effortActual: taskEdit.effortActual,
        priorityCode: taskEdit.priorityCode,
        assignId: taskEdit.assignId,
        ownerShipId: taskEdit.ownerShipId,
        status: taskEdit.status,
        taskDesc: taskEdit.taskDesc,
        hrmsTaskMasterId: taskEdit.hrmsTaskMasterId,
        actionType: "UPDATE",
      }));
    }
  }, [taskEdit]);

  const handleTaskInputChange = (e) => {
    const { name, value } = e.target;
    if (value && /^[\s]/.test(value)) {
      e.preventDefault();
      return;
    } else if (name === "ownerShipId") {
      setTask(prev => ({
        ...prev,
        assignId: value,
        ownerShipId: value,
      }));
    } else {
      setTask({ ...task, [name]: value });
    }
  };

  const handleDateChangeForTaskIput = (date, name) => {
    if (name === "startDate") {
      setTask(prevData => ({
        ...prevData,
        endDate: null
      }));
    }
    if (name === "endDate" && task.startDate) {
      const start = new Date(task.startDate);
      const formattedEndDate = format(new Date(date), "yyyy-MM-dd");
      const formattedStartDate = format(new Date(start), "yyyy-MM-dd");

      if (formattedEndDate < formattedStartDate) {
        Swal.fire({
          icon: "warning",
          title: "Invalid Date",
          text: "End Date must be after Start Date.",
          confirmButtonText: "OK",
        });
        return;
      }
    }

    const formattedDate = format(new Date(date), "yyyy-MM-dd");
    setTask({ ...task, [name]: formattedDate });
  };


  const handleCommentChange = (e) => {
    const { name, value } = e.target;
    if (value && /^[\s]/.test(value)) {
      e.preventDefault();
      return;
    }
    if (/^[a-zA-Z\s]*$/.test(value)) {
      setComment({ ...comment, [name]: value });
    }
  };

  const handleWorklogInputChange = (e) => {
    const { name, value } = e.target;
    if (name === "totalHour") {

      const numericTotal = Number(totalHours);
      const numericValue = Number(value);

      const isSaturday = new Date().getDay() === 6;

      const limitText = isSaturday
        ? "Total worklog hours on Saturday cannot exceed 7 hours."
        : "Total worklog hours in one day cannot exceed 9 hours.";

      if ((isSaturday && (numericTotal + numericValue) > 7) || ((numericTotal + numericValue) > 9)) {

        const hasRows =
          todaysWorklogDataByid?.taskWorkLogList &&
          todaysWorklogDataByid.taskWorkLogList.length > 0;

        const headerHtml = hasRows
          ? `
    <div style="
      font-weight:bold;
      padding:6px 0;
      border-bottom:1px solid #ccc;
      display:flex;
      justify-content:space-between;
      width:100%;
      margin-bottom:6px;
    ">
      <span style="width:140px;">Task No</span>
      <span>Total Hours</span>
    </div>
  `
          : "";

        const worklogText = hasRows ? "Your Today's Work Logs:" : "";

        const rowsHtml =
          headerHtml +
          (todaysWorklogDataByid?.taskWorkLogList
            ?.map(
              item => `
      <div style="
        padding:6px 0;
        border-bottom:1px solid #eee;
        display:flex;
        justify-content:space-between;
        width:100%;
      ">
        <span style="width:140px;"><b>${item.taskNo}</b></span>
        <span>${item.totalHour} hour(s)</span>
      </div>`
            )
            .join("") || "");

        Swal.fire({
          icon: "warning",
          title: "Limit Exceeded",
          html: `
      <div style="text-align:left; font-size:14px; line-height:1.5;">
        <b>${worklogText}</b><br/><br/>
        ${rowsHtml}
        
        <div style="
          padding:10px; 
          background:#f8f9fa; 
          border-radius:6px; 
          margin-top:15px;
        ">
          <b>Entered New Hours:</b> ${numericValue}<br/>
          <span style="color:#d9534f; font-weight:bold;">
            ${limitText}
          </span>
        </div>
      </div>
    `,
          confirmButtonColor: "#3085d6",
        });

        return;
      }


      if (/^(0|[1-9]\d*)?$/.test(value)) {
        let newValue = value;

        if (parseInt(newValue) > 24) {
          newValue = 24;
          alert("Hours should be less then 24.");
          setworkLog("");
          return;
        }


        setworkLog({ ...workLog, [name]: value });
      }
    } else {
      setworkLog({ ...workLog, [name]: value });
    }
  };

  const handleClose = () => {
    setShow(false);
    setShowTable(false);
  }
  const handleCloseCommentModal = () => {
    setshowCommentModal(false);
    setValue("");
    setComment({});
    setMentionedUsers([]);
  }

  const handleCloseWorkLog = () => {
    setworkLog({
      date: new Date(),
      totalHour: "",
      remarks: "",
    });
    setshowWorklogModal(false);
  }
  const handleSubmit = (e) => {
    e.preventDefault();

    if (!task.projectCode || !task.type || !task.priorityCode || !task.ownerShipId || !task.assignId || !task.status) {
      Swal.fire({
        icon: "warning",
        title: "Warning",
        text: "Please fill all the required fields.",
        timer: 2000,
      });
      return;
    }
    const taskData = {
      ...task,
      effortActual: task.effortActual || 0,
      effortReq: task.effortReq || 0,
      endDate: format(new Date(task.endDate), "yyyy-MM-dd"),
      startDate: format(new Date(task.startDate), "yyyy-MM-dd"),
    };

    if (task.endDate < task.startDate) {
      Swal.fire({
        icon: "warning",
        title: "Invalid Date",
        text: "End Date must be after Start Date.",
        confirmButtonText: "OK",
      });
      return; // Prevent setting the invalid end date
    }
    Swal.fire({
      title: "Are you sure?",
      html: `Do you want to submit the task details?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, submit it!",
      cancelButtonText: "No, cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(getcreateTask(taskData, token))
          .then(({ success }) => {
            if (success) {
              handleClose();
              dispatch(taskMasterList(token, pageNumber - 1, pageSize, loginId, roleName, searchText));
              Swal.fire({
                icon: "success",
                title: "Success!",
                text: "Task details submitted successfully.",
                timer: 4000,
                showConfirmButton: false,
              });
            } else {
              Swal.fire({
                title: "Error!",
                text: "There was an error submitting the task details.",
                icon: "error",
                confirmButtonText: "OK",
              });
            }
          })
          .catch(() => {
            Swal.fire({
              title: "Error!",
              text: "There was an error in catch submitting the task details.",
              icon: "error",
              timer: 5000,
              confirmButtonText: "OK",
            });
          });
      }
    });
  };
  const handleSubmitComment = (e) => {
    e.preventDefault();

    const payload = {
      comments: value,
      taggedUserIds: mentionedUsers.map(u => u.id)
    };


    Swal.fire({
      title: "Are you sure?",
      html: `Do you want to submit the Comment ?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, submit it!",
      cancelButtonText: "No, cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        const commentdata = {
          taskMasterId: taskId,
          loginId: loginId,
          commentsId: "",
          name: "",
          action: "",
          createdDate: "",
          comments: comment.comments,
          taggedLoginIds: payload?.taggedUserIds,
        };
        dispatch(addTaskComment(commentdata, token))
          .then(({ success }) => {
            if (success) {
              handleCloseCommentModal(false);
              setComment(true);
              dispatch(getCommentData(taskId, token));
              setshowCommentModal(true);
              setValue("");
              setComment({});
              setMentionedUsers([]);
              Swal.fire({
                icon: "success",
                title: "Success!",
                text: "Comment Added successfully.",
                timer: 4000,
                showConfirmButton: false,
              });
            } else {
              Swal.fire({
                title: "Error!",
                text: "There was an error submitting the Comment.",
                icon: "error",
                confirmButtonText: "OK",
              });
            }
          })
          .catch(() => {
            Swal.fire({
              title: "Error!",
              text: "There was an error in  submitting the Comment.",
              icon: "error",
              timer: 5000,
              confirmButtonText: "OK",
            });
          });
      }
    });
  };

  const handelSubmitWorklog = (e) => {
    e.preventDefault();
    const workLogDatas = {
      taskMasterId: taskId,
      userId: loginId,
      date: format(workLog.date, "yyyy-MM-dd"),
      totalHour: workLog.totalHour,
      remarks: workLog.remarks,
    };
    Swal.fire({
      title: "Are you sure?",
      html: `Do you want to submit the WorkLog ?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, submit it!",
      cancelButtonText: "No, cancel",
    }).then((result) => {
      if (result.isConfirmed) {

        dispatch(addTaskWorklog(workLogDatas, token))
          .then(({ success }) => {
            if (success) {
              handleCloseWorkLog(false);
              setworkLog({
                date: new Date(),
                totalHour: "",
                remarks: "",
              });
              dispatch(getWorklogData(taskId, token, loginId));
              dispatch(fetchTodyasWorkLogDataByLogind(loginId, token));
              setshowWorklogModal(true);
              Swal.fire({
                icon: "success",
                title: "Success!",
                text: "WorkLog submitted successfully.",
                timer: 4000,
                showConfirmButton: false,
              });
            } else {
              Swal.fire({
                title: "Error!",
                text: "There was an error submitting the WorkLog.",
                icon: "error",
                confirmButtonText: "OK",
              });
            }
          })
          .catch(() => {
            Swal.fire({
              title: "Error!",
              text: "There was an error in catch submitting the WorkLog.",
              icon: "error",
              timer: 5000,
              confirmButtonText: "OK",
            });
          });
      }
    });
  };

  const handelfetchTaskDetails = (e) => {
    dispatch(getTaskDetails(e.hrmsTaskMasterId, token));
    dispatch(getTaskTransactionDetails(e.hrmsTaskMasterId, token));
    dispatch(getEmpListByProjectId(null, e?.projectCode, token));

    setonEditing(true);
    setShow(true);
  };

  const handelfetchComment = (e) => {
    dispatch(getTaskDetails(e.hrmsTaskMasterId, token));
    setTaskId(e.hrmsTaskMasterId);
    setshowCommentModal(true);
    setTaskNumber(e.taskNo);
    setTaskTitle(e.title);
    dispatch(getCommentData(e.hrmsTaskMasterId, token));
    dispatch(getEmpListByProjectId(null, e?.projectCode, token));
  };

  const handelfetchWorklog = (e) => {
    dispatch(getWorklogData(e.hrmsTaskMasterId, token, loginId));
    dispatch(fetchTodyasWorkLogDataByLogind(loginId, token));
    setTaskId(e.hrmsTaskMasterId);
    setshowWorklogModal(true);
    setTaskNumber(e.taskNo);
    setTaskTitle(e.title);
  };

  const Tooltip = ({ text, children }) => {
    return (
      <div className="tooltip-container">
        {children}
        <div className="tooltip">{text}</div>
      </div>
    );
  };

  const totalHours =
    todaysWorklogDataByid?.taskWorkLogList?.reduce(
      (sum, item) => sum + Number(item.totalHour || 0),
      0
    ) || 0;


  const columns = [
    {
      name: "Task No",
      selector: (row) => row.taskNo || "-",
      sortable: true,
    },
    {
      name: "Project",
      selector: (row) => row.projectCode || "-",
      sortable: true,
    },
    {
      name: "Date Range",
      selector: (row) => (
        <div>
          {row.startDate} <br />
          {row.endDate}
        </div>
      ),
      sortable: true,
    },

    {
      name: "Ownership",
      selector: (row) => row.ownershipName?.trim() || "-",
      sortable: true,
    },
    {
      name: "Assign To",
      selector: (row) => row.assignName || '-',
      sortable: true,
    },
    {
      name: "Status",
      selector: (row) => row.status || "-",
      sortable: true,
    },
    {
      name: "Task Title",
      selector: (row) => row.title || "-",
      sortable: true,
    },

    {
      name: "Action",
      selector: (row) => row,
      sortable: false,
      cell: (row) => (
        <div>
          {(roleName === "ROLE_ADMIN" || loginId === row.assignId) && (
            <Tooltip text="Edit Task">
              <Icon
                icon={FaEdit}
                variant="warning"
                className="me-3"
                onClick={() => handelfetchTaskDetails(row)}
              />
            </Tooltip>
          )}
          {loginId === row.assignId && (
            <>
              <Tooltip text="View Worklog">
                <Icon
                  icon={IoTimeOutline}
                  variant="primary"
                  className="me-3"
                  onClick={() => handelfetchWorklog(row)}
                />
              </Tooltip>
            </>
          )}
          <Tooltip text="View Comments">
            <Icon
              icon={BiSolidMessageRoundedDetail}
              variant="success"
              onClick={() => handelfetchComment(row)}
            />
          </Tooltip>

        </div>
      ),
    },
  ];

  const handleShowTable = (e) => {
    e.preventDefault();
    setShowTable(prev => !prev);
  };

  const projectOptions = getProjectAsLoginId.map(p => ({
    value: p.projectCode,
    label: p.projectName,
    projectMasterId: p.projectMasterId,
  }));
  const taskTypeOptions = taskType.map(p => ({
    value: p.ticketTypeId,
    label: p.ticketType,
  }));
  const taskPriorityoptions = taskPriority.map(p => ({
    value: p.priorityCode,
    label: p.priorityName,
  }));

  const empOptions = empListByProjectId.map(p => ({
    value: p.loginId,
    label: `${p?.firstName || ""} ${p?.lastName || ""}`.trim(),
  }));

  const taskStatusOptions = taskStatus.map(p => ({
    value: p.status,
    label: p.description,
  }));

  const statusOption = [
    {
      value: "O",
      label: "To Do",
    },
  ];

  const handleProjectChange = (selectedOption) => {
    dispatch(getEmpListByProjectId(selectedOption?.projectMasterId, null, token));
    setTask(prev => ({
      ...prev,
      projectCode: selectedOption?.value || ""
    }))
  }

  const users = (empListByProjectId || []).map(p => ({
    id: p.loginId, //  used as ID (goes to backend)
    display: `${p?.firstName || ""} ${p?.lastName || ""}`.trim() //  shown in UI
  }));

  return (
    <div>
      <Navbar></Navbar>
      <div className="main-content">
        <div className="container-fluid mt-4">
          <div className="row mb-3 justify-content-end align-items-center">
            <div className="col-auto d-flex align-items-center">
              <button className="btn btn-primary" onClick={handleShow}>
                CREATE TASK
              </button>
            </div>
          </div>



          <NewGlobalDataTable
            columns={columns}
            data={tasklist.taskMaster}
            tableName={'TASK DETAILS'}
            setPageSize={setPageSize}
            setPageNumber={setPageNumber}
            setFilterText={setSearchText}
            totalRecord={tasklist.totalRecord}
          />



          {/* This is WorklogModal */}

          {showWorklogModal && <div className="modal-backdrop fade show"></div>}
          <div
            className={`modal fade worklog-modal ${showWorklogModal ? "show d-block" : ""}`}
            tabIndex="-1"
            role="dialog"
          >
            <div className="modal-dialog modal-xl" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Work Logs for Task No : {taskNumber || ""} - {taskTitle || ""}</h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={handleCloseWorkLog}
                    aria-label="Close"
                  ></button>
                </div>
                <div className="modal-body">
                  <form onSubmit={handelSubmitWorklog}>
                    <div className="row">
                      <div className="col-md-2">
                        <label htmlFor="date" className="form-label">
                          Date <span className="text-danger">*</span>
                        </label>

                        <DatePicker
                          selected={workLog.date ? new Date(workLog.date) : null}
                          onChange={(date) =>
                            setworkLog({
                              ...workLog,
                              date: date ? format(date, "yyyy-MM-dd") : "",
                            })
                          }
                          className="form-control"
                          dateFormat="dd-MM-yyyy"
                          placeholderText="Date"
                          showYearDropdown
                          showMonthDropdown
                          dropdownMode="select"
                          onKeyDown={(event) => event.preventDefault()}
                          disabled
                        />
                      </div>
                      <div className="col-md-2">
                        <label htmlFor="totalHour" className="form-label">
                          Hours <span className="text-danger">*</span>
                        </label>
                        <input
                          type="number"
                          name="totalHour"
                          value={workLog.totalHour || ""}
                          onChange={handleWorklogInputChange}
                          className="form-control"
                          id="totalHour"
                          max="9"
                          min="0"
                          required
                        />
                      </div>
                      <div className="col-md-7">
                        <label htmlFor="remarks" className="form-label">
                          Remarks <span className="text-danger">*</span>
                        </label>
                        <textarea
                          name="remarks"
                          id="remarks"
                          className="form-control"
                          rows={2}
                          value={workLog.remarks ?? ""}
                          onChange={handleWorklogInputChange}
                          required
                        />

                      </div>
                      <div className="col-md-1 d-flex align-items-end">
                        <button
                          className="btn btn-success"
                          name="workLog"
                          type="submit"
                          style={{ minWidth: "80px" }}
                        >
                          SUBMIT
                        </button>
                      </div>
                    </div>
                  </form>
                  <br />
                  <div className="worklog-container mt-2">

                    {/* PC TABLE VIEW */}
                    <div className="d-none d-md-block">
                      <div
                        className="table-scroll-wrapper"
                        style={{ maxHeight: "250px", overflowY: "auto" }}
                      >
                        <table className="table worklog-table mb-0">
                          <thead className="sticky-top bg-white">
                            <tr>
                              <th>SN</th>
                              <th>Date</th>
                              <th>Total Hour</th>
                              <th>Remarks</th>
                            </tr>
                          </thead>

                          <tbody>
                            {Array.isArray(taskWorklogdata) && taskWorklogdata.length > 0 ? (
                              taskWorklogdata.map((log, index) => (
                                <tr key={index}>
                                  <td>{index + 1}</td>
                                  <td>{log?.date || "-"}</td>
                                  <td>{log?.totalHour ?? "-"}</td>
                                  <td className="text-start">{log?.remarks || "-"}</td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan="4" className="text-center">
                                  No logs available
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>


                    {/* MOBILE CARD VIEW */}
                    <div className="d-md-none">
                      {Array.isArray(taskWorklogdata) && taskWorklogdata.length > 0 ? (
                        taskWorklogdata.map((log, index) => (
                          <div className="worklog-card shadow-sm" key={index}>
                            <div className="worklog-card-header">
                              <span className="worklog-sn">#{index + 1}</span>
                              <span className="worklog-date">{log?.date || "-"}</span>
                            </div>

                            <div className="worklog-card-body">
                              <p><b>Total Hour:</b> {log?.totalHour ?? "-"}</p>
                              <p className="remarks-line"><b>Remarks:</b> {log?.remarks || "-"}</p>
                            </div>
                          </div>
                        ))
                      ) : (
                        <div className="text-center">No logs available</div>
                      )}
                    </div>

                  </div>

                  <div className="text-danger">
                    <strong>Note:</strong>{" "}
                    <em>Break time is not counted in total work-log hours.</em>
                  </div>

                </div>
              </div>
            </div>
          </div>

          {/* this is comment modal */}

          {showCommentModal && <div className="modal-backdrop fade show"></div>}
          <div
            className={`modal fade comment-modal ${showCommentModal ? "show d-block" : ""}`}
            tabIndex="-1"
            role="dialog"
          >
            <div className="modal-dialog modal-lg">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Comment Details for Task No : {taskNumber || ""} - {taskTitle || ""}</h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={handleCloseCommentModal}
                  ></button>
                </div>
                <div className="modal-body comment-modal-body">
                  <h5 className="section-title">Project Details</h5>

                  {/* Project Info Section */}
                  <div className="row g-3 project-details">
                    <div className="col-md-4 col-12">
                      <label>Project</label>
                      <div className="info-box">{taskEdit.projectCode}</div>
                    </div>
                    <div className="col-md-4 col-12">
                      <label>Module</label>
                      <div className="info-box">{taskEdit.module}</div>
                    </div>
                    <div className="col-md-4 col-12">
                      <label>Task Title</label>
                      <div className="info-box">{taskEdit.title}</div>
                    </div>
                    <div className="col-12">
                      <label>Description</label>
                      <div className="info-box">{taskEdit.taskDesc}</div>
                    </div>
                  </div>

                  {/* Comment Input Section */}
                  <h5 className="section-title mt-4">Add Comment</h5>
                  <form onSubmit={handleSubmitComment}>
                    {/* <textarea
                      className="form-control comment-textarea"
                      name="comments"
                      value={comment.comments || ""}
                      onChange={handleCommentChange}
                      id="comments"
                      placeholder="Write your comment here..."
                      required
                    ></textarea> */}

                    <MentionsInput
                      value={value}
                      onChange={(e, newValue, newPlainTextValue, mentions) => {
                        setValue(newValue);
                        setComment({ ...comment, comments: newPlainTextValue });
                        // Remove duplicates
                        const uniqueMentions = mentions.filter(
                          (m, index, self) =>
                            index === self.findIndex((t) => t.id === m.id)
                        );

                        setMentionedUsers(uniqueMentions);
                      }}
                      placeholder="Type @ to tag users..."
                      className="form-control"
                    >
                      <Mention
                        trigger="@"
                        data={users.filter(
                          u => !mentionedUsers.some(m => m.id === u.id) // prevent duplicate in dropdown
                        )}
                        displayTransform={(id, display) => `@${display}`}
                      />
                    </MentionsInput>

                    <button type="submit" className="btn btn-success mt-3">
                      Add Comment
                    </button>
                  </form>

                  {/* Comment History Section */}
                  <h5 className="section-title mt-4">Previous Comments</h5>
                  <div className="comment-list">
                    {Array.isArray(taskCommentData) && taskCommentData.length > 0 ? (
                      taskCommentData.map((c, index) => {
                        // Safe null checks
                        const rawDate = c?.createdDate || "";
                        let formattedDate = "-";

                        // Try parsing only if date exists
                        try {
                          if (rawDate) {
                            const parsedDate = parse(
                              rawDate,
                              "dd-MM-yyyy HH:mm",
                              new Date()
                            );

                            formattedDate = isValid(parsedDate)
                              ? format(parsedDate, "dd MMM yyyy h:mm a")
                              : "-";
                          }
                        } catch {
                          formattedDate = "-";
                        }

                        return (
                          <div key={index} className="comment-card">
                            <div className="comment-header">
                              <span className="comment-author">{c?.name || "Unknown"}</span>
                              <span className="comment-date">{formattedDate}</span>
                            </div>
                            <div className="comment-text">{c?.comments || "-"}</div>
                          </div>
                        );
                      })
                    ) : (
                      <div className="text-center text-muted mt-3">No comments available</div>
                    )}

                  </div>

                </div>

              </div>
            </div>
          </div>

          {/* this is create task modal */}
          {show && <div className="modal-backdrop fade show"></div>}

          <div
            className={`modal fade task-modal ${show ? "show d-block" : ""}`}
            tabIndex="-1"
            role="dialog"
          >
            <div className="modal-dialog modal-lg">
              <div className="modal-content">
                <div className="modal-header">
                  <h1 className="modal-title fs-5" id="modalLabeltaskManager">
                    {onEditing ? "Update Task Details" : "Add Task Details"}
                  </h1>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={handleClose}
                  ></button>
                </div>
                <div className="modal-body">
                  {/*---------------------------- form inputs--------------- */}
                  <form onSubmit={handleSubmit}>
                    <div className="row g-3">
                      <div className="col-md-3">
                        <label
                          htmlFor="projectCode"
                          className="form-label"
                          id="modalLabelProject"
                        >
                          Project<span className="text-danger">*</span>
                        </label>
                        <Select
                          options={projectOptions}
                          value={projectOptions.find(opt => opt.value === task.projectCode) || null}
                          onChange={(selectedOption) => { handleProjectChange(selectedOption) }

                          }
                          required
                        />
                      </div>

                      <div className="col-md-3">
                        <label htmlFor="module" className="form-label">
                          Module<span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          name="module"
                          value={task.module || ""}
                          onChange={handleTaskInputChange}
                          className="form-control"
                          id="module"
                          required
                        />
                      </div>
                      <div className="col-md-6">
                        <label
                          htmlFor="title"
                          className="form-label"
                          id="modalLabelTaskTitle"
                        >
                          Task Title<span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          name="title"
                          value={task.title || ""}
                          onChange={handleTaskInputChange}
                          className="form-control"
                          id="title"
                          placeholder="Enter Task Title.."
                          required
                        />
                      </div>
                    </div>
                    {/*---------------------------- Line 2--------------- */}
                    <div className="row g-3">
                      <div className="col-md-3">
                        <label htmlFor="startDate" className="form-label">
                          Start Date<span className="text-danger">*</span>
                        </label>
                        <DatePicker
                          selected={task.startDate ? new Date(task.startDate) : null}
                          onChange={(date) => handleDateChangeForTaskIput(date, "startDate")}
                          className="form-control"
                          dateFormat="dd-MM-yyyy"
                          placeholderText="Start Date"
                          showYearDropdown
                          showMonthDropdown
                          dropdownMode="select"
                          onKeyDown={(event) => event.preventDefault()}
                          required
                        />
                      </div>
                      <div className="col-md-3">
                        <label
                          htmlFor="endDate"
                          className="form-label"
                          id="modalLabelEndDt"
                        >
                          End Date<span className="text-danger">*</span>
                        </label>
                        <DatePicker
                          selected={task.endDate ? new Date(task.endDate) : null}
                          onChange={(date) => handleDateChangeForTaskIput(date, "endDate")}
                          className="form-control"
                          dateFormat="dd-MM-yyyy"
                          placeholderText="End Date"
                          showYearDropdown
                          showMonthDropdown
                          dropdownMode="select"
                          onKeyDown={(event) => event.preventDefault()}
                          required
                        />
                      </div>
                      <div className="col-md-3">
                        <label
                          htmlFor="type"
                          className="form-label"
                          id="modalLabelType"
                        >
                          Type<span className="text-danger">*</span>
                        </label>
                        <Select
                          options={taskTypeOptions}
                          value={taskTypeOptions.find(opt => opt.value === task.type) || null}
                          onChange={(selectedOption) =>
                            setTask(prev => ({
                              ...prev,
                              type: selectedOption?.value || ""
                            }))
                          }
                          required
                        />
                      </div>
                      <div className="col-md-3">
                        <label
                          htmlFor="priorityCode"
                          className="form-label"
                          id="modalLabelPriority"
                        >
                          Priority<span className="text-danger">*</span>
                        </label>
                        <Select
                          options={taskPriorityoptions}
                          value={taskPriorityoptions.find(opt => opt.value === task.priorityCode) || null}
                          onChange={(selectedOption) =>
                            setTask(prev => ({
                              ...prev,
                              priorityCode: selectedOption?.value || ""
                            }))
                          }
                          required
                        />
                      </div>
                    </div>

                    {/*---------------------------- Line 5--------------- */}
                    <div className="row g-3">
                      <div className="col-md-4">
                        <label
                          htmlFor="ownerShipId"
                          className="form-label"
                          id="modalLabelAssign"
                        >
                          Ownership To<span className="text-danger">*</span>
                        </label>
                        <Select
                          options={empOptions}
                          value={empOptions.find(opt => opt.value === task.ownerShipId) || null}
                          onChange={(selectedOption) =>
                            setTask(prev => ({
                              ...prev,
                              assignId: selectedOption?.value,
                              ownerShipId: selectedOption?.value,
                            }))

                          }
                          required
                          isDisabled={onEditing}
                        />
                      </div>
                      <div className="col-md-4">

                        <label
                          htmlFor="assignId"
                          className="form-label"
                          id="modalLabelAssign"
                        >
                          Assign To<span className="text-danger">*</span>
                        </label>

                        <Select
                          options={empOptions}
                          value={empOptions.find(opt => opt.value === task.assignId) || null}
                          onChange={(selectedOption) =>
                            setTask(prev => ({
                              ...prev,
                              assignId: selectedOption?.value
                            }))

                          }
                          required
                        />
                      </div>
                      <div className="col-md-4">
                        <label
                          htmlFor="status"
                          className="form-label"
                          id="modalLabelStatus"
                        >
                          Status<span className="text-danger">*</span>
                        </label>

                        <Select
                          options={
                            task.actionType === "INSERT"
                              ? taskStatusOptions.filter((opt) => opt.value === "O")
                              : taskStatusOptions
                          }
                          value={taskStatusOptions.find(opt => opt.value === task.status) || null}
                          onChange={(selectedOption) =>
                            setTask(prev => ({
                              ...prev,
                              status: selectedOption?.value
                            }))

                          }
                          required
                        />
                      </div>
                    </div>

                    <div className="row g-3">
                      <div className="form-group mb-3">
                        <label className="form-label" htmlFor="taskDesc">
                          Description<span className="text-danger">*</span>
                        </label>
                        <textarea
                          className="form-control"
                          name="taskDesc"
                          value={task.taskDesc || ""}
                          onChange={handleTaskInputChange}
                          required
                          id="taskDesc"
                        ></textarea>
                      </div>
                    </div>

                    {taskTransactionList?.length > 0 && onEditing && (
                      <div className="task-transaction-wrapper mb-3">

                        <a href="#" onClick={handleShowTable} className="task-toggle-link">
                          {showTable ? "Hide Task Transaction" : "Click Here To See The Task Transaction"}
                        </a>

                        {showTable && (
                          <>
                            {/* PC TABLE VIEW */}
                            <div className="task-table-pc d-none d-md-block">
                              <div className="task-table-scroll">
                              <table className="table custom-task-table">
                                <thead>
                                  <tr>
                                    <th>S.No</th>
                                    <th>Assign From</th>
                                    <th>Assign To</th>
                                    <th>Status From</th>
                                    <th>Status To</th>
                                    <th>Created By</th>
                                    <th>Created Date</th>
                                  </tr>
                                </thead>

                                <tbody>
                                  {taskTransactionList.map((item, index) => (
                                    <tr key={item.taskMasterTransactionId}>
                                      <td>{index + 1}</td>
                                      <td>{item?.assignIdFrom || "-"}</td>
                                      <td>{item?.assignIdTo || "-"}</td>
                                      <td>{item?.statusFrom || "-"}</td>
                                      <td>{item?.statusTo || "-"}</td>
                                      <td>{item?.createdBy || "-"}</td>
                                      <td>
                                        {item.createdDate
                                          ? format(new Date(item.createdDate), "dd-MM-yyyy hh:mm a")
                                          : "-"}
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                               </div>
                            </div>

                            {/* MOBILE CARD VIEW */}
                            <div className="task-cards-mobile d-md-none">
                              {taskTransactionList.map((item, index) => (
                                <div key={item.taskMasterTransactionId} className="task-card shadow-sm">

                                  <div className="task-card-header">
                                    <strong>#{index + 1}</strong>
                                    <span className="cs-span">
                                      {item.createdDate
                                        ? format(new Date(item.createdDate), "dd-MM-yyyy hh:mm a")
                                        : "-"}
                                    </span>
                                  </div>

                                  <div className="task-card-body">
                                    <p><b>Assign From:</b> {item.assignIdFrom || "-"}</p>
                                    <p><b>Assign To:</b> {item.assignIdTo || "-"}</p>
                                    <p><b>Status From:</b> {item.statusFrom || "-"}</p>
                                    <p><b>Status To:</b> {item.statusTo || "-"}</p>
                                    <p><b>Created By:</b> {item.createdBy || "-"}</p>
                                  </div>

                                </div>
                              ))}
                            </div>
                          </>
                        )}
                      </div>
                    )}


                    <div className="row">
                      <div className="col text-center">
                        <button type="submit" className={`btn ${onEditing ? "btn-warning" : "btn-success"}`}>
                          {onEditing ? "UPDATE" : "SUBMIT"}
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default TaskDetails;
